(function () {
  'use strict';

  class MvFadeIn {
    constructor(wrap) {
      if (!wrap) return; // wrapがnullなら即終了

      this.wrap = wrap;
      this.copy = wrap.querySelector('.page-top__mv__copy');
      this.copyEn = this.copy?.querySelector('.en') ?? null;
      this.copyJaTxt1 = this.copy?.querySelector('.ja .txt1 .ani-slideIn') ?? null;
      this.copyJaTxt2 = this.copy?.querySelector('.ja .txt2 .ani-slideIn') ?? null;
      this.description = wrap.querySelector('.page-top__mv__description');
      this.slider = wrap.querySelector('.page-top__mv__slider');

      this.init();
    }

    anim() {
      const elementsWithDelays = [
        { el: this.copyEn, delay: 300 },
        { el: this.copyJaTxt1, delay: 450 },
        { el: this.copyJaTxt2, delay: 600 },
        { el: this.description, delay: 1300 },
        { el: this.slider, delay: 1300 },
      ];

      elementsWithDelays.forEach(({ el, delay }) => {
        if (!el) return;

        setTimeout(() => {
          requestAnimationFrame(() => {
            el.classList.add('is-active');
          });
        }, delay);
      });
    }

    init() {
      this.anim();
    }
  }

  const target = document.getElementById('js-top-mv');
  if (target) {
    new MvFadeIn(target);
  }

  // シンボルの再描画
  const symbol = document.querySelector('.page-top__mv__symbol');
  if (symbol) {
    symbol.style.position = 'static';
    symbol.style.opacity = '0';
    setTimeout(()=>{
      symbol.removeAttribute('style');
    }, 10);

    // シンボルアニメーションの再生・停止を制御
    // 再生/停止ボタン（.c-motionBtn__btn）クリック時に、top-slider.jsから呼び出される
    const symbolImage = symbol.querySelector('img');

    if (symbolImage) {
      window.pauseSymbolAnimation = function () {
        symbolImage.classList.add('is-paused');
      };

      window.resumeSymbolAnimation = function () {
        symbolImage.classList.remove('is-paused');
      };
    }
  }
})();
